/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest
 */
export interface WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest {
    /**
     * 
     * @type {string}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest
     */
    refundCallbackUrl?: string | null;
}

/**
 * Check if a given object implements the WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest interface.
 */
export function instanceOfWebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequestFromJSON(json: any): WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest {
    return WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequestFromJSONTyped(json, false);
}

export function WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'refundCallbackUrl': !exists(json, 'refund_callback_url') ? undefined : json['refund_callback_url'],
    };
}

export function WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequestToJSON(value?: WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'refund_callback_url': value.refundCallbackUrl,
    };
}

